/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useRef, useState } from "react";
import { Link, useHistory } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { Popup, ToolbarItem } from "devextreme-react/popup";
import { formatMessage } from "devextreme/localization";
import notify from "devextreme/ui/notify";
import LoadPanel from "devextreme-react/load-panel";
import Form, { Label, StringLengthRule } from "devextreme-react/form";
import { Item } from "devextreme-react/toolbar";
import {
  IsPermisionPathRequired,
  getOvertimeApproval,
} from "../../../redux/actions";
import { responseMiddleware, responseOvertime } from "../../../redux/reducers";
import { useScreenSize } from "../../../utils/media-query";
import OvertimeApprovalTable from "./OvertimeApprovalTable";
import "./style.scss";
import UsingIntl from "../../../services/using_intl";
import { useAuth } from "../../../contexts/auth";
import { postApproval } from "../../../services/approval";
import PopupConfig from "../../../common/popup";
import { getStatusApproval, axios, getCurrentPath } from "../../../common";

export default function OvertimeApprovalList() {
  const formData = useRef({});
  const dispatch = useDispatch();
  let dataGrid = useRef(null);
  const { isXSmall, isSmall } = useScreenSize();
  const history = useHistory();
  const { middlewarePath: middleware, loading: middlewareLoading } =
    useSelector(responseMiddleware);
  const currentPath = getCurrentPath();
  const { overtimeApproval } = useSelector(responseOvertime);
  const { user } = useAuth();
  const { handleOpenPopup, handleClosePopup, popupConfig } = PopupConfig();
  const [filter, setFilter] = useState({
    Status: null,
    FromDate: null,
    ToDate: null,
    EmployeeOid: user?.EmployeeOid,
    Comment: "",
  });

  useEffect(() => {
    dispatch(IsPermisionPathRequired(currentPath));
    UsingIntl("P0021");
  }, [dispatch]);

  useEffect(() => {
    if (middleware) {
      const { ReadState, NavigateState } = middleware;
      if (
        (NavigateState !== undefined && !NavigateState) ||
        (ReadState !== undefined && !ReadState)
      ) {
        history.push("/403");
        return;
      }
    }
  }, [middleware]);

  useEffect(() => {
    const getData = async () => {
      const state = getStatusApproval(window.location.href);
      setFilter({ ...filter, Status: state });
    };
    getData();
  }, []);

  const handleChangeSelectBox = async () => {
    const newPayload = {
      ...filter,
      Status: filter.Status !== null ? `${filter.Status}` : null,
    };
    dispatch(getOvertimeApproval(newPayload));
  };

  useEffect(() => {
    handleChangeSelectBox();
  }, [filter.Status]);
  const handleRefreshDataGrid = () => {
    dataGrid.current.instance.refresh();
  };

  const executeApproval = async (e) => {
    try {
       await postApproval(e, "ApproveOvertime", {
        headers: {
          MappedState: 6,
        },
      });
      handleClosePopup();
      handleRefreshDataGrid();
      handleChangeSelectBox();
      notify("Successfully updated", "success", 2000);
    } catch (error) {
      handleChangeSelectBox();
      notify(error.response.data.message, error.response.data.msgType, 3000);
    }
  };

  const handleSendApprove = async (data) => {
    let validateData = [];
    let payload = {
      EmployeeOid: filter.EmployeeOid,
      Comment: formData.current.Comment,
    };
    if (data.Oid || data.items) {
      if (data.Oid) {
        validateData.push({
          OvertimeDate: data.OvertimeDate,
          Employee: { Oid: data.EmployeeOid },
          Oid: data.Oid,
          TotalHours: data.TotalHours,
          IsApproval: true,
          Comment : "",
        });
      } else {
        // eslint-disable-next-line array-callback-return
        data.items.map((item) => {
          validateData.push({
            OvertimeDate: item.OvertimeDate,
            Employee: { Oid: item.EmployeeOid },
            Oid: item.Oid,
            TotalHours: item.TotalHours,
            IsApproval: true,
            Comment :"",
          });
        });
      }
      payload = {
        ...payload,
        ApprovalStatus: 1,
        Transactions: data.items || [data],
        Comment :"",
      };
    } else {
      payload = {
        ...payload,
        ApprovalStatus: 0,
        Transactions: popupConfig.data.items || [popupConfig.data],
      };
    }
    try {
      const { data } = await axios.post(
        "ValidateOvertimeEmployees",
        validateData
      );
      if (data.error300h.length === 0 && data.error40h.length === 0) {
        executeApproval(payload);
        return;
      }
      let messageConfirm = "";
      if (data.error300h.length > 0) {
        messageConfirm =
          data?.error300h[0]?.message +
          `:${data.error300h?.map((item) => item.employeeName)}` +
          "\n";
      }
      if (data.error40h.length > 0) {
        messageConfirm +=
          data?.error40h[0]?.message +
          `: ${data.error40h?.map((item) => item.employeeName)}`;
      }
      // eslint-disable-next-line no-restricted-globals
      if (confirm(messageConfirm)) {
        // custom message
        executeApproval(payload);
      } else {
        return;
      }
    } catch (error) {
      notify(error.response.data.message, error.response.data.msgType, 3000);
    }
  };

  const renderViewPopup = () => {
    formData.current.ApprovalStatus = popupConfig.data.type;
    formData.current.Comment = "";
    return (
      <Popup
        visible={popupConfig.popupVisible}
        onHiding={handleClosePopup}
        title={
          popupConfig.data.type === 1
            ? formatMessage("PopupTitleApprove")
            : formatMessage("PopupTitleReject")
        }
        showTitle={true}
        width={isSmall || isXSmall ? "100%" : "550px"}
        height={isSmall || isXSmall ? "400px" : "400px"}
        borderRadius={10}
        closeOnOutsideClick={false}
      >
        <Form formData={formData.current}>
          <Item dataField="Comment" editorType="dxTextArea">
            <StringLengthRule max="250" />
            <Label text={formatMessage("Comment")} />
          </Item>
        </Form>
        <ToolbarItem
          widget="dxButton"
          toolbar="bottom"
          location="after"
          onClick={handleSendApprove}
          options={{
            icon: "save",
            type: "success",
            text: formatMessage("Save"),
          }}
        />
        <ToolbarItem
          widget="dxButton"
          toolbar="bottom"
          location="after"
          onClick={handleClosePopup}
          options={{
            icon: "close",
            type: "primary",
            text: formatMessage("Cancel"),
          }}
        />
      </Popup>
    );
  };

  return (
    <div>
      <LoadPanel visible={middlewareLoading} />
      {/* Breadcrumb */}
      <div className={"breadcrumb"}>
        <div className={"breadcrumb-left"}>
          <div className={"breadcrumb-page-title"}>
            {formatMessage("OvertimeApproval")}
          </div>
        </div>
        <div className={"breadcrumb-right"}>
          <Link to="/overtime-registration/list" className={"breadcrumb-item"}>
            {formatMessage("Overtime")}
          </Link>
          <span className={"breadcrumb-item active"}>
            {formatMessage("OvertimeApproval")}
          </span>
        </div>
      </div>

      <div className={"section"}>
        <div className={"section-body"}>
          {popupConfig.popupVisible && renderViewPopup()}
          <OvertimeApprovalTable
            dataGrid={dataGrid}
            middleware={middleware}
            handleOpenPopup={handleOpenPopup}
            approvalList={overtimeApproval}
            handleChangeSelectBox={handleChangeSelectBox}
            filter={filter}
            setFilter={setFilter}
            handleSendApprove={handleSendApprove}
          />
        </div>
      </div>
    </div>
  );
}
